export default __webpack_public_path__ + "static/media/29.b21c5b2c.webp";